import React from 'react';
import { Table, Button } from 'antd';
import { DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { ReportFile } from '../../../../store/reports/reports.actions';

interface ReportsTableProps {
  reports: ReportFile[];
  loading: boolean;
  currentPage: number;
  pageSize: number;
  total: number;
  onDownload: (fileName: string) => void;
  onReload: () => void;
  onTableChange: (pagination: any) => void;
}

export const ReportsTable: React.FC<ReportsTableProps> = ({
  reports,
  loading,
  currentPage,
  pageSize,
  total,
  onDownload,
  onReload,
  onTableChange,
}) => {
  const columns: ColumnsType<ReportFile> = [
    {
      title: 'File Name',
      dataIndex: 'fileName',
      key: 'fileName',
    },
    {
      title: 'Upload Date',
      dataIndex: 'createdDate',
      key: 'createdDate',
      render: (date: string) => {
        if (!date) return '-';
        try {
          return new Date(date).toLocaleString('en-US');
        } catch {
          return date;
        }
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: ReportFile) => (
        <Button 
          type="primary" 
          icon={<DownloadOutlined />} 
          onClick={() => onDownload(record.fileName)}
        >
          Download
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0 }}>Reports</h3>
        <Button 
          type="default" 
          icon={<ReloadOutlined />} 
          onClick={onReload}
          loading={loading}
        >
          Refresh
        </Button>
      </div>
      <Table 
        columns={columns} 
        dataSource={reports} 
        loading={loading}
        rowKey="fileName"
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => 
            `${range[0]}-${range[1]} of ${total} files`,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        onChange={onTableChange}
        locale={{
          emptyText: loading ? 'Loading...' : 'No uploaded files',
        }}
      />
    </div>
  );
}; 